export enum InvoiceDetailsPaymentsColumns {
    Date,
    Description,
    Amount,
    PaymentNo,
}